/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LinkEnum = "contact" | "container" | "shipment" | "ticket" | "vessel" | "voyage" | "%future added value";
export type LinkSet_data = {
    readonly title: string | null;
    readonly inline: boolean | null;
    readonly links: ReadonlyArray<{
        readonly key: string | null;
        readonly type: LinkEnum | null;
        readonly " $fragmentRefs": FragmentRefs<"LinkCard_data">;
    }> | null;
    readonly " $refType": "LinkSet_data";
};
export type LinkSet_data$data = LinkSet_data;
export type LinkSet_data$key = {
    readonly " $data"?: LinkSet_data$data;
    readonly " $fragmentRefs": FragmentRefs<"LinkSet_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkSet_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Link",
      "kind": "LinkedField",
      "name": "links",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkCard_data"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LinkSet",
  "abstractKey": null
};
(node as any).hash = 'fbad5f4c5237c9a13e285ad82ce4336c';
export default node;
